import { Btn } from "@/components/Btn";

export function LoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="card card-pad" style={{ textAlign: "center" }}>
      <div className="serif" style={{ fontSize: 20 }}>
        Couldn&apos;t load stats
      </div>
      <div className="muted" style={{ marginTop: 6, fontSize: 13 }}>
        Check the network tab and try again. Your session is still valid.
      </div>
      <div style={{ marginTop: 14 }}>
        <Btn variant="primary" onClick={onRetry}>
          Try again
        </Btn>
      </div>
    </div>
  );
}
